import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center text-slate2" data-testid="auth-checking">
        Duke verifikuar sesionin…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}
